import { Easing, motion } from "framer-motion";

const backdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
  exit: { opacity: 0 },
};

const badgeVariants = {
  hidden: { scale: 0.96, opacity: 0 },
  visible: { scale: 1, opacity: 1, transition: { duration: 0.35 } },
  exit: { scale: 0.98, opacity: 0, transition: { duration: 0.2 } },
};

const dotVariants = {
  hidden: { y: 0, opacity: 0.4 },
  visible: (i: number) => ({
    y: [0, -6, 0],
    opacity: [0.4, 1, 0.4],
    transition: {
      delay: i * 0.15,
      duration: 0.9,
      repeat: Infinity,
      ease: "easeInOut" as Easing,
    },
  }),
};

export default function AppLoadingScreen() {
  return (
    <motion.div
      className="loading-backdrop fixed inset-0 z-[60] flex items-center justify-center"
      initial="hidden"
      animate="visible"
      exit="exit"
      variants={backdropVariants}>
      <motion.div
        className="flex flex-col items-center gap-4 rounded-xl border border-gray bg-white/60 px-8 py-10 text-center shadow-xl shadow-lac-leman/10 backdrop-blur"
        variants={badgeVariants}>
        <motion.p
          className="text-2xl font-semibold"
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}>
          Loading your journey
        </motion.p>

        <div className="mt-6 flex items-center gap-2 text-lac-leman">
          {[0, 1, 2].map(i => (
            <motion.span
              key={i}
              className="h-2 w-2 rounded-full bg-lac-leman"
              custom={i}
              variants={dotVariants}
              initial="hidden"
              animate="visible"
            />
          ))}
        </div>
      </motion.div>
    </motion.div>
  );
}
